import React from 'react';

interface Props  {
  issueId?: string;
  activePanel: string;
}
const LinkedRisks: React.FC<Props> = (props: Props) => {
  return (
    <div>
      Linked risks
    </div>
  );
};

export default LinkedRisks;
